module.exports = __webpack_public_path__ + "static/img/ad_2.7b31f5d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/comm/images/document-conversion/ad_2.jpg
// module id = NE4u
// module chunks = 2